<div
  class="p-5 mb-4 flex flex-col w-full bg-white dark:bg-dark-card border rounded-sm border-gray-200 dark:border-dark-border shadow-sm"
>
  <h3 class="flex items-center justify-between mb-2 text-[16px] font-semibold" *appIsEmpty>
    <ng-content select="[title]"></ng-content>
  </h3>

  <div class="text-base h-full">
    <ng-content></ng-content>
  </div>
</div>
